/* eslint-disable no-unused-vars */
import _ from 'lodash';
import moment from 'moment';
import { cleanString } from '@utilities/attachments';
import {
  createAtOrSyncedDateFilter,
  dueDateFilter,
  scheduledDateFilter
} from '@utilities/date-filters';

export const filterTasks = ({
  filters,
  type = '',
  data = [],
  notWantTagMaps = false,
  store,
  getTaskTab = false,
  hideTodoTab = false,
  isAppLive = false,
  noDistanceTab = false
}) => {
  const { tasks: reduxTasks, cache, picklists, settings } = store;
  const {
    sitesMap = {},
    equipmentsMap = {},
    equipments: cacheEquipments = [],
    sites: cacheSites = []
  } = cache;

  const { picklistsMap = {} } = picklists;

  const sitesSiteTypeDataMap = {},
    sitesSiteStatusDataMap = {},
    sitesAreaHierarchyTreeDataMap = {},
    sitesWorkOrderPriorityDataMap = {},
    equipmentsEquipmentCategoryData = {},
    equipmentsEquipmentTypeData = {};

  const {
    area,
    proximity,
    siteType,
    siteStatus,
    taskType,
    priority,
    workOrderPriority,
    assign,
    dueDate,
    scheduledDate,
    download,
    searched,
    recurringTemplate,
    taskStatus,
    workOrderType,
    createdAt,
    inspectionRun,
    syncedDate: syncedDateFilter,
    hseEventCategory,
    checkRecurrancePriority,
    equipmentCategory = {
      value: []
    },
    equipmentType = {
      value: []
    }
  } = filters;

  const filterDueDate = dueDate;

  const inspectionTypeMap = filters?.inspectionType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedEquipmentCategoryMap = equipmentCategory?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedEquipmentTypeMap = equipmentType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const checkTypeMap = filters?.checkType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const hseEventCategoryMap = hseEventCategory?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const inspectionRunMap = inspectionRun?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedAreaMap = area?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});
  const workOrderTypeMap = workOrderType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});
  const selectedSiteTypeMap = siteType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});
  const selectedSiteStatusMap = siteStatus?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});
  const selectedTaskType = taskType?.value?.includes('All')
    ? {
        'Work Order': true,
        'Work Request': true,
        Inspection: true,
        Check: true,
        HSE: true,
        'New or edited asset': true
      }
    : taskType?.value?.reduce((acc, curr) => {
        acc[
          curr === 'Work orders'
            ? 'Work Order'
            : curr === 'Work requests'
            ? 'Work Request'
            : curr === 'Inspections'
            ? 'Inspection'
            : curr === 'HSE events'
            ? 'HSE'
            : curr === 'Checks'
            ? 'Check'
            : curr === 'New or edited asset'
            ? 'New or edited asset'
            : 'Work Order'
        ] = true;
        return acc;
      }, {});

  const selectedTaskStatus = taskStatus?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedWorkOrderPriority = workOrderPriority?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedRecurrancePriority = checkRecurrancePriority?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedWorkOrderRecurringTemplateMap = recurringTemplate?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const list =
    type &&
    ['Check', 'Inspection', 'Work Order', 'hseEvents', 'Work Request', 'newOrEditAssets'].includes(
      type
    )
      ? type === 'Work Request'
        ? data.filter((task) => task.newWorkRequest || task?.entityType === 'WorkRequest')
        : data.filter((task) => {
            let aType =
              type === 'hseEvents'
                ? 'HSE'
                : type === 'newOrEditAssets'
                ? 'New or edited asset'
                : type;
            return task.type === aType;
          })
      : data;
  let tasks = list
    ?.filter((task) => {
      const {
        id,
        type,
        priorityId,
        title,
        sites = [],
        siteId,
        description,
        incidentNumber,
        dueDate,
        nextDue,
        startDate,
        syncedDate,
        equipmentId,
        equipments = [],
        syncDateCustom = null,
        createdDate = null,
        users,
        equipmentAsset = {},
        structureAsset = {},
        siteAsset = {},
        rtInterval,
        rtData = {},
        taskFooter,
        newWorkRequest = false,
        customAssignedTaskValue = [],
        rtName,
        rtNumber,
        hseData,
        mocData,
        structureData,
        ncrData,
        pipelineData,
        status,
        typeId,
        detailInspectionsInfo,
        inspectionTypeId,
        inspectionFormId,
        inspectionType,
        RunName,
        pipelineAsset,
        runNumber,
        recurrencePriorityId,
        recurrence,
        identifier,
        location,
        NextScheduled,
        due,
        taskCardHeaderTitle,
        reconciliationNumber,
        taskCardWorkStatus = ''
      } = task;

      !notWantTagMaps && (sitesWorkOrderPriorityDataMap[priorityId] = true);

      if (
        assign?.value?.length > 0 &&
        !assign?.value?.some((r) => customAssignedTaskValue?.includes(r))
      )
        return false;

      const sitesAsset = [siteId, ...(sites || []).filter((site) => site !== siteId)].filter(
        (site) => cacheSites[sitesMap[site]]
      );
      const equipmentsAssets = [
        equipmentId,
        ...equipments.filter((equipment) => equipment !== equipmentId)
      ]?.filter((equipment) => cacheEquipments[equipmentsMap[equipment]]);

      if (
        taskType.value.length > 0 &&
        !selectedTaskType[
          newWorkRequest
            ? 'Work Request'
            : type === 'New Work Order'
            ? 'Work Order'
            : type === 'New Work Request'
            ? 'Work Request'
            : type
        ]
      )
        return false;

      if (taskStatus?.value?.length > 0 && !selectedTaskStatus[status]) return false;

      if (
        filters?.inspectionType?.value?.length > 0 &&
        !(inspectionTypeMap[inspectionFormId] || inspectionTypeMap[inspectionTypeId])
      )
        return false;

      if (filters?.checkType?.value?.length > 0 && !checkTypeMap[inspectionTypeId]) return false;

      if (hseEventCategory?.value?.length > 0 && !hseEventCategoryMap[inspectionType]) return false;

      // if (inspectionRun?.value.length > 0 && !inspectionRunMap[RunName?.trim()]) return false;
      if (inspectionRun?.value.length > 0 && !inspectionRunMap[`${runNumber} - ${RunName}`?.trim()])
        return false;

      if (
        recurringTemplate.value.length > 0 &&
        !selectedWorkOrderRecurringTemplateMap[`${rtNumber} - ${rtName?.trim()}`]
      )
        return false;
      if (workOrderType?.value?.length > 0 && !workOrderTypeMap[typeId]) return false;

      // work orders data points map start
      const tasksDataPointsMapCombine = [
        ...(task?.dataPointsForSearch || []),
        ...(task?.dataPoints || [])
      ];

      const tasksDataPointsMap = tasksDataPointsMapCombine?.reduce(
        (obj, item) =>
          Object.assign(obj, {
            [item.key]:
              item.key === 'responsibleUsers' || item.key === 'inspectors'
                ? users
                  ? (users && users.toString()) || ''
                  : ''
                : `${item.value}`
          }),
        {}
      );

      // work orders data points map end

      if (searched) {
        const filterObject = filterTaskObject({
          taskCardWorkStatus,
          equipmentAsset,
          siteAsset,
          structureAsset,
          id,
          title: title || reconciliationNumber,
          taskCardHeaderTitle,
          users,
          tasksDataPointsMap,
          //TODO: work order data points
          description,
          // rtInterval,
          // type:
          //   task?.typeId && picklistsMap[task?.typeId]?.value
          //     ? picklistsMap[task?.typeId]?.value
          //     : '',

          incidentNumber,
          rtData,
          taskFooter,
          hseData,
          mocData,
          structureData,
          ncrData,
          pipelineData,
          detailInspectionsInfo,
          inspectionTitle: task?.inspectionType,
          pipelineAsset,
          recurrence,
          identifier,
          location
        });

        const cleanInput = cleanString(searched);

        if (
          !Object.values(filterObject).some((value) => {
            return cleanString(String(value)).includes(cleanInput);
          })
        )
          return false;
      }

      if (workOrderPriority.value.length > 0 && !selectedWorkOrderPriority[priorityId])
        return false;

      if (
        checkRecurrancePriority?.value?.length > 0 &&
        !selectedRecurrancePriority[recurrencePriorityId]
      )
        return false;

      let areaCheck = area.value.length === 0;
      let proximityCheck = proximity.value === 0;
      let siteTypeCheck = siteType.value.length === 0;
      let siteStatusCheck = siteStatus.value.length === 0;

      for (const siteId of sitesAsset) {
        const site = cacheSites[sitesMap[siteId]];

        !notWantTagMaps && (sitesSiteTypeDataMap[site?.siteType] = true);
        !notWantTagMaps && (sitesSiteStatusDataMap[site?.status] = true);
        !notWantTagMaps && (sitesAreaHierarchyTreeDataMap[site?.areaHierarchy] = true);

        if (!areaCheck && area.value.length > 0 && selectedAreaMap[site?.areaHierarchy])
          areaCheck = true;
        if (!siteTypeCheck && siteType.value.length > 0 && selectedSiteTypeMap[site?.siteType])
          siteTypeCheck = true;
        if (!siteStatusCheck && siteStatus.value.length > 0 && selectedSiteStatusMap[site?.status])
          siteStatusCheck = true;
        if (!proximityCheck && proximity.value && site?.distance && site.distance < proximity.value)
          proximityCheck = true;
      }

      let equipmentCategoryCheck = equipmentCategory.value.length === 0 ? true : false;
      let equipmentTypeCheck = equipmentType.value.length === 0 ? true : false;

      for (const equipmentsAsset of equipmentsAssets) {
        const equipmentValue = cacheEquipments[equipmentsMap[equipmentsAsset]];

        const equipmentSite = equipmentValue.siteId || '';
        const distance = (equipmentSite && cacheSites[sitesMap[equipmentSite]]?.distance) || 0;
        if (!proximityCheck && proximity.value && distance && distance < proximity.value)
          proximityCheck = true;

        !notWantTagMaps &&
          equipmentValue?.equipmentCategory &&
          (equipmentsEquipmentCategoryData[equipmentValue?.equipmentCategory] = true);

        !notWantTagMaps &&
          equipmentValue?.equipmentType &&
          (equipmentsEquipmentTypeData[equipmentValue?.equipmentType] = true);

        if (
          !equipmentCategoryCheck &&
          equipmentCategory?.value?.length > 0 &&
          equipmentValue?.equipmentCategory &&
          selectedEquipmentCategoryMap[equipmentValue?.equipmentCategory] &&
          type === 'New or edited asset'
        )
          equipmentCategoryCheck = true;

        if (
          !equipmentTypeCheck &&
          equipmentType?.value?.length > 0 &&
          equipmentValue?.equipmentType &&
          selectedEquipmentTypeMap[equipmentValue?.equipmentType] &&
          type === 'New or edited asset'
        )
          equipmentTypeCheck = true;
      }

      if (!areaCheck) return false;
      if (!siteTypeCheck) return false;
      if (!proximityCheck) return false;
      if (!siteStatusCheck) return false;

      if (!equipmentTypeCheck) return false;
      if (!equipmentCategoryCheck) return false;

      const dueCon = _.isArray(filterDueDate.value) ? !filterDueDate.value.includes('') : true;
      const createAtCon = _.isArray(createdAt?.value) ? !createdAt?.value.includes('') : true;
      const syncedDateCon = _.isArray(syncedDateFilter?.value)
        ? !syncedDateFilter?.value.includes('')
        : true;

      const scheduleCon = _.isArray(scheduledDate.value) ? !scheduledDate.value.includes('') : true;
      if (
        !_.isEmpty(filterDueDate.value) &&
        dueCon &&
        !dueDateFilter({
          taskDueDate: dueDate ? dueDate : due ? due : nextDue,
          dueDateFilter: filterDueDate
        })
      )
        return false;

      if (
        !_.isEmpty(scheduledDate.value) &&
        scheduleCon &&
        !scheduledDateFilter({
          startDate: startDate || NextScheduled,
          syncedDate: syncedDate,
          dueDateFilter: scheduledDate
        })
      )
        return false;

      if (
        !_.isEmpty(createdAt?.value) &&
        createAtCon &&
        !createAtOrSyncedDateFilter({ dateForFilter: createdDate, filterSelectedDate: createdAt })
      )
        return false;
      if (
        !_.isEmpty(syncedDateFilter?.value) &&
        syncedDateCon &&
        !createAtOrSyncedDateFilter({
          dateForFilter: syncedDate,
          filterSelectedDate: syncedDateFilter
        })
      )
        return false;

      return true;
    })
    ?.map((a) => {
      const dataPoints = a?.dataPointsForSearch || [];
      const cleanInput = a?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

      if (a?.type === 'New or edited asset') {
        let equipmentAssetFilterData = a?.equipmentAssetFilterData?.prepareTasksEquipments?.map(
          (x) => {
            const dataPoints = x?.dataPointsForSearch || [];
            const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

            let newDataPointsList = dataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
            });

            const siteDataPoints = x?.siteAsset?.dataPointsForSearch || [];
            const cleanInputForSiteDataPoints =
              x?.siteAsset?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

            let newDataPointsForSiteList = siteDataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(
                cleanInputForSiteDataPoints
              );
            });

            return {
              ...x,
              dataPoints: searched
                ? [...(x?.dataPoints || []), ...newDataPointsList]
                : x?.dataPoints || [],
              siteAsset: {
                ...x?.siteAsset,
                dataPoints:
                  x?.siteAsset?.dataPoints?.length > 0 ||
                  x?.siteAsset?.dataPointsForSearch?.length > 0
                    ? searched
                      ? [...(x?.siteAsset?.dataPoints || []), ...(newDataPointsForSiteList || [])]
                      : x?.siteAsset?.dataPoints || []
                    : []
              }
            };
          }
        );

        return {
          ...a,
          equipmentAssetFilterData:
            a?.equipmentAssetFilterData?.equipmentsIds?.length > 0
              ? {
                  equipmentsIds: a?.equipmentAssetFilterData?.equipmentsIds,
                  prepareTasksEquipments: equipmentAssetFilterData
                }
              : {}
        };
      } else if (a?.type === 'HSE') {
        let siteAsset = a?.siteAsset?.prepareTasksSites?.map((x) => {
          const dataPoints = x?.dataPointsForSearch || [];
          const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';
          let newDataPointsList = dataPoints.filter((item) => {
            let titleAndValueCombineObject = `${item.title} : ${item.value}`;
            return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
          });
          return {
            ...x,
            dataPoints: searched
              ? [...(x?.dataPoints || []), ...newDataPointsList]
              : x?.dataPoints || []
          };
        });

        return {
          ...a,
          siteAsset:
            a?.siteAsset?.sitesIds?.length > 0
              ? {
                  sitesIds: a?.siteAsset?.sitesIds,
                  prepareTasksSites: siteAsset
                }
              : {}
        };
      } else {
        let newDataPointsList = dataPoints.filter((item) => {
          let titleAndValueCombineObject =
            item.key === 'responsibleUsers'
              ? a?.users
                ? (a?.users && a?.users.toString()) || ''
                : ''
              : `${item.value}`;

          return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
        });

        let sitesAssetFilterData = a?.sitesAssetFilterData?.prepareTasksSites?.map((x) => {
          const dataPoints = x?.dataPointsForSearch || [];

          const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

          let newDataPointsList = dataPoints.filter((item) => {
            let titleAndValueCombineObject = `${item.title} : ${item.value}`;
            return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
          });

          return {
            ...x,
            dataPoints: searched ? [...x.dataPoints, ...newDataPointsList] : x?.dataPoints
          };
        });

        let equipmentAssetFilterData = a?.equipmentAssetFilterData?.prepareTasksEquipments?.map(
          (x) => {
            const dataPoints = x?.dataPointsForSearch || [];
            const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

            let newDataPointsList = dataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
            });

            const siteDataPoints = x?.siteAsset?.dataPointsForSearch || [];
            const cleanInputForSiteDataPoints =
              x?.siteAsset?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

            let newDataPointsForSiteList = siteDataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(
                cleanInputForSiteDataPoints
              );
            });

            return {
              ...x,
              dataPoints: searched ? [...x.dataPoints, ...newDataPointsList] : x?.dataPoints,
              siteAsset: {
                ...x?.siteAsset,
                dataPoints:
                  x?.siteAsset?.dataPoints?.length > 0 ||
                  x?.siteAsset?.dataPointsForSearch?.length > 0
                    ? searched
                      ? [...(x?.siteAsset?.dataPoints || []), ...(newDataPointsForSiteList || [])]
                      : x?.siteAsset?.dataPoints || []
                    : []
              }
            };
          }
        );

        let structureAsset = a?.structureAsset?.prepareTasksStructure?.map((x) => {
          const dataPoints = x?.dataPointsForSearch || [];
          const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

          let newDataPointsList = dataPoints.filter((item) => {
            let titleAndValueCombineObject = `${item.title} : ${item.value}`;
            return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
          });

          const siteDataPoints = x?.siteAsset?.dataPointsForSearch || [];
          const cleanInputForSiteDataPoints =
            x?.siteAsset?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

          let newDataPointsForSiteList = siteDataPoints.filter((item) => {
            let titleAndValueCombineObject = `${item.title} : ${item.value}`;
            return cleanString(String(titleAndValueCombineObject)).includes(
              cleanInputForSiteDataPoints
            );
          });

          return {
            ...x,
            dataPoints: searched ? [...x.dataPoints, ...newDataPointsList] : x?.dataPoints,
            siteAsset: {
              ...x?.siteAsset,
              dataPoints:
                x?.siteAsset?.dataPoints?.length > 0 ||
                x?.siteAsset?.dataPointsForSearch?.length > 0
                  ? searched
                    ? [...(x?.siteAsset?.dataPoints || []), ...(newDataPointsForSiteList || [])]
                    : x?.siteAsset?.dataPoints || []
                  : []
            }
          };
        });

        let pipelineAsset = a?.pipelineAsset?.prepareTasksPipeline?.map((x) => {
          const dataPoints = x?.dataPointsForSearch || [];
          const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

          let newDataPointsList = dataPoints.filter((item) => {
            let titleAndValueCombineObject = `${item.title} : ${item.value}`;
            return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
          });

          let multipleSiteAssets = x?.multipleSiteAssets?.map((multipleSiteAsset) => {
            const prepareTasksSites = multipleSiteAsset?.prepareTasksSites?.map((x) => {
              const dataPoints = x?.dataPointsForSearch || [];

              const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

              let newDataPointsList = dataPoints.filter((item) => {
                let titleAndValueCombineObject = `${item.title} : ${item.value}`;
                return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
              });

              return {
                ...x,
                dataPoints: searched ? [...x.dataPoints, ...newDataPointsList] : x?.dataPoints
              };
            });

            return {
              ...multipleSiteAsset,
              prepareTasksSites: prepareTasksSites
            };
          });

          return {
            ...x,
            dataPoints: searched ? [...x.dataPoints, ...newDataPointsList] : x?.dataPoints,
            multipleSiteAssets
          };
        });

        return {
          ...a,
          dataPoints: searched
            ? [...(a?.dataPoints || []), ...newDataPointsList]
            : a?.dataPoints || [],

          sitesAssetFilterData:
            a?.sitesAssetFilterData?.sitesIds?.length > 0
              ? {
                  sitesIds: a?.sitesAssetFilterData?.sitesIds,
                  prepareTasksSites: sitesAssetFilterData
                }
              : {},

          equipmentAssetFilterData:
            a?.equipmentAssetFilterData?.equipmentsIds?.length > 0
              ? {
                  equipmentsIds: a?.equipmentAssetFilterData?.equipmentsIds,
                  prepareTasksEquipments: equipmentAssetFilterData
                }
              : {},

          structureAsset:
            a?.structureAsset?.prepareTasksStructure?.length > 0
              ? {
                  sitesIds: a?.structureAsset?.sitesIds,
                  prepareTasksStructure: structureAsset
                }
              : {},

          pipelineAsset:
            a?.pipelineAsset?.prepareTasksPipeline?.length > 0
              ? {
                  sitesIds: a?.pipelineAsset?.sitesIds,
                  prepareTasksPipeline: pipelineAsset
                }
              : {}
        };
      }
    });

  const tasksMap = !notWantTagMaps
    ? tasks?.reduce((acc, curr) => {
        acc[curr.id] = true;
        return acc;
      }, {})
    : {};

  const tasksMapDataPoints = !notWantTagMaps
    ? tasks?.reduce((acc, curr) => {
        acc[curr.id] = {
          tasksAndRecordsDataPoints: curr.dataPoints,
          sitesAssetFilterData: curr.sitesAssetFilterData,
          equipmentAssetFilterData: curr?.equipmentAssetFilterData || {},
          structureAsset: curr?.structureAsset || {},
          pipelineAsset: curr?.pipelineAsset || {},
          siteAsset: curr?.siteAsset || {}
        };
        return acc;
      }, {})
    : {};

  let selectedTab = '0';
  let selectedFilter = { DISTANCE: true };
  if (getTaskTab) {
    if (tasks?.find((x) => x?.status === 'To do')) {
      selectedTab = '0';
      selectedFilter = isAppLive ? { DISTANCE: true } : { DUE: true };
    } else if (tasks?.find((x) => x?.status === 'In progress')) {
      selectedTab = hideTodoTab ? '0' : '1';
      selectedFilter = isAppLive ? { RECENT: true } : { RECENT: true };
    } else if (tasks?.find((x) => x?.status === 'Pending sync')) {
      selectedTab = hideTodoTab ? '1' : '2';
      selectedFilter = isAppLive ? { RECENT: true } : { RECENT: true };
    } else if (tasks?.find((x) => x?.status === 'Synced')) {
      selectedTab = hideTodoTab ? '2' : '3';
      selectedFilter = isAppLive ? { RECENT: true } : { RECENT: true };
    }

    if (noDistanceTab) {
      selectedFilter = selectedFilter['DISTANCE'] ? { DUE: true } : selectedFilter;
    }
  }

  return {
    tasks,
    tasksMap,
    tasksMapDataPoints,
    sitesSiteTypeDataMap,
    sitesSiteStatusDataMap,
    sitesAreaHierarchyTreeDataMap,
    sitesWorkOrderPriorityDataMap,
    equipmentsEquipmentCategoryData,
    equipmentsEquipmentTypeData,
    selectedTab,
    selectedFilter
  };
};

export const filterTasksWithPromise = ({ args }) => {
  return new Promise((resolve) => {
    const response = filterTasks({ ...args });
    resolve(response);
  });
};

const filterTaskObject = ({
  equipmentAsset,
  siteAsset,
  structureAsset,
  users,
  recurrence,
  id,
  title,
  type,
  description,
  incidentNumber,
  rtInterval,
  rtData,
  hseData,
  mocData,
  structureData,
  ncrData,
  pipelineData,
  detailInspectionsInfo,
  inspectionTitle,
  pipelineAsset,
  identifier,
  location,
  tasksDataPointsMap,
  reconciliationNumber,
  taskCardHeaderTitle,
  taskCardWorkStatus = ''
}) => {
  const equipmentObject = equipmentAsset?.prepareTasksEquipments?.map((x) => {
    const { dataPoints = [], siteAsset = {}, dataPointsForSearch = [] } = x;

    const equipmentDataPointsCombine = [...dataPointsForSearch, ...dataPoints];

    const dataPointsEquipmentObject = equipmentDataPointsCombine.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    const equipmentSiteDataPoints = [
      ...(siteAsset?.dataPoints || []),
      ...(siteAsset?.dataPointsForSearch || [])
    ];
    const dataPointsSiteObject = equipmentSiteDataPoints?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    return {
      title: x?.title || '',
      subtitle: x?.subtitle || '',
      siteTitle: siteAsset?.title || '',
      siteSubtitle: siteAsset?.subtitle || '',
      kmValue: siteAsset?.kmValue || '',
      unit: siteAsset?.unit || '',

      ...dataPointsEquipmentObject,
      ...dataPointsSiteObject
    };
  });

  const siteObject = siteAsset?.prepareTasksSites?.map((x) => {
    const { dataPoints = [], dataPointsForSearch = [] } = x;

    const dataPointsCombine = [...dataPointsForSearch, ...dataPoints];

    const dataPointsSiteObject = dataPointsCombine?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    return {
      title: x?.title || '',
      subtitle: x?.subtitle || '',
      kmValue: x?.kmValue || '',
      unit: x?.unit || '',
      ...dataPointsSiteObject
    };
  });

  const transformedObjEquipment = equipmentObject?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-equipment`] = obj[key];
    });
    return acc;
  }, {});

  const transformedObjSite = siteObject?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-site`] = obj[key];
    });
    return acc;
  }, {});

  const hseDataFilterObjects = !_.isEmpty(hseData) ? appliesToTypesDataPoints(hseData, 'hse') : {};
  const mocDataFilterObjects = !_.isEmpty(mocData) ? appliesToTypesDataPoints(mocData, 'moc') : {};

  const ncrDataFilterObjects = !_.isEmpty(ncrData) ? appliesToTypesDataPoints(ncrData, 'ncr') : {};

  const structureObject = structureAsset?.prepareTasksStructure?.map((x) => {
    const { dataPoints = [], siteAsset = {}, dataPointsForSearch = [] } = x;

    const siteDataPointsCombine = [...dataPoints, ...dataPointsForSearch];

    const equipmentSiteDataPoints = [
      ...(siteAsset?.dataPoints || []),
      ...(siteAsset?.dataPointsForSearch || [])
    ];

    const dataPointsSiteObject = equipmentSiteDataPoints?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    const dataPointsStructureObject = siteDataPointsCombine?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    return {
      name: x?.name || '',
      structureType: x?.structureType || '',
      siteTitle: siteAsset?.title || '',
      siteSubtitle: siteAsset?.subtitle || '',
      kmValue: siteAsset?.kmValue || '',
      unit: siteAsset?.unit || '',
      ...dataPointsStructureObject,
      ...dataPointsSiteObject
    };
  });

  const transformedObjStructure = structureObject?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-structure`] = obj[key];
    });
    return acc;
  }, {});

  const pipelineObject = pipelineAsset?.prepareTasksPipeline?.map((x) => {
    const { dataPoints = [], multipleSiteAssets = [], dataPointsForSearch = [] } = x;

    const siteDataPointsCombine = [...dataPoints, ...dataPointsForSearch];

    let dataPointsPipelineSiteObject = multipleSiteAssets?.map((x) => {
      const { dataPoints = [], dataPointsForSearch = [] } = x?.prepareTasksSites?.[0] || {};

      const siteDataPointsCombine1 = [...dataPoints, ...dataPointsForSearch];

      const dataPointsSiteObject = siteDataPointsCombine1?.reduce(
        (obj, item) =>
          Object.assign(obj, { [`${item.key}-${item.value}`]: `${item.title} : ${item.value}` }),
        {}
      );

      return {
        title: x?.title || '',
        subtitle: x?.subtitle || '',
        kmValue: x?.kmValue || '',
        unit: x?.unit || '',
        ...dataPointsSiteObject
      };
    });

    const dataPointsForPipelineObject = siteDataPointsCombine?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    dataPointsPipelineSiteObject = dataPointsPipelineSiteObject?.reduce((acc, obj, index) => {
      Object.keys(obj).forEach((key) => {
        acc[`${key}-pipeline-site`] = obj[key];
      });
      return acc;
    }, {});

    return {
      fromLocation: x?.fromLocation || '',
      licenseNumber: x?.licenseNumber || '',
      fromLocationAndLicenseNumber: `${x?.licenseNumber}-${x?.lineNumber}`,
      toLocation: x?.toLocation || '',
      ...dataPointsForPipelineObject,
      ...dataPointsPipelineSiteObject
    };
  });

  const transformedObjPipeline = pipelineObject?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-pipeline`] = obj[key];
    });
    return acc;
  }, {});

  const detailInspectionsInfoObjects = detailInspectionsInfo?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-inspection-info`] = obj[key];
    });
    return acc;
  }, {});

  const filterObject = {
    // id,
    title,
    reconciliationNumber,
    taskCardHeaderTitle,
    taskCardWorkStatus,
    type,
    description,
    incidentNumber,
    rtInterval,
    inspectionTitle,
    recurrence,
    identifier,
    location,
    users: (users && users.toString()) || '',
    ...transformedObjSite,
    ...transformedObjEquipment,
    rtDataId: rtData?.id || '',
    rtDataTitle: rtData?.title || '',
    ...transformedObjStructure,
    ...hseDataFilterObjects,
    ...mocDataFilterObjects,
    ...ncrDataFilterObjects,
    ...transformedObjPipeline,
    ...detailInspectionsInfoObjects,
    ...tasksDataPointsMap
  };
  return filterObject;
};

const appliesToTypesDataPoints = (typeOfData = {}, keyName = 'hse') => {
  const hseSiteAssetDataPoints =
    typeOfData?.siteAsset?.dataPoints &&
    typeOfData?.siteAsset?.dataPoints?.reduce(
      (obj, item) =>
        Object.assign(obj, { [`${item.key}-${keyName}-site`]: `${item.title} : ${item.value}` }),
      {}
    );

  const hseEquipmentAssetDataPoints =
    typeOfData?.equipmentAsset?.dataPoints &&
    typeOfData?.equipmentAsset?.dataPoints?.reduce(
      (obj, item) =>
        Object.assign(obj, {
          [`${item.key}-${keyName}-equipment`]: `${item.title} : ${item.value}`
        }),
      {}
    );

  const hseEquipmentSiteAssetDataPoints =
    typeOfData?.equipmentAsset?.siteAsset &&
    typeOfData?.equipmentAsset?.siteAsset?.dataPoints &&
    typeOfData?.equipmentAsset?.siteAsset?.dataPoints?.reduce(
      (obj, item) =>
        Object.assign(obj, {
          [`${item.key}-${keyName}-equipment-site`]: `${item.title} : ${item.value}`
        }),
      {}
    );

  const pipeLineDataPoints = typeOfData?.pipelineAsset?.reduce(
    (obj, item, index) =>
      Object.assign(obj, {
        [`pipelineAsset-fromLocation-${index}`]: item?.fromLocation || '',
        [`pipelineAsset-toLocation-${index}`]: item?.toLocation || '',
        [`pipelineAsset-licenseNumber-${index}`]: item?.licenseNumber || ''
      }),
    {}
  );

  const structureDataPoints = typeOfData?.structureData?.map((x, index) => {
    const { dataPoints = [], siteAsset = {} } = x;

    const dataPointsEquipmentObject = dataPoints.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );
    const dataPointsSiteObject = siteAsset?.dataPoints?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    return {
      [`structureData-structureType-${index}`]: x?.structureType,
      [`structureData-name-${index}`]: x?.name,
      ...dataPointsEquipmentObject,
      ...dataPointsSiteObject
    };
  });

  const typeOfDataFilterObjects = {
    [`recordNumber-${keyName}`]: typeOfData?.recordNumber || '',
    [`recordTitle-${keyName}}`]: typeOfData?.recordTitle || '',
    [`siteAsset-title-${keyName}`]: typeOfData?.siteAsset?.title || '',
    [`siteAsset-subtitle-${keyName}`]: typeOfData?.siteAsset?.subtitle || '',
    [`siteAsset-kmValue-${keyName}`]: typeOfData?.siteAsset?.kmValue || '',
    [`siteAsset-unit-${keyName}`]: typeOfData?.siteAsset?.unit || '',

    [`equipmentAsset-title-${keyName}`]: typeOfData?.equipmentAsset?.title || '',
    [`equipmentAsset-subtitle-${keyName}`]: typeOfData?.equipmentAsset?.subtitle || '',

    [`equipmentAsset-siteAsset-title-${keyName}`]:
      typeOfData?.equipmentAsset?.siteAsset?.title || '',
    [`equipmentAsset-siteAsset-subtitle-${keyName}`]:
      typeOfData?.equipmentAsset?.siteAsset?.subtitle || '',
    [`equipmentAsset-siteAsset-kmValue-${keyName}`]:
      typeOfData?.equipmentAsset?.siteAsset?.kmValue || '',
    [`equipmentAsset-siteAsset-unit-${keyName}`]: typeOfData?.equipmentAsset?.siteAsset?.unit || '',

    ...pipeLineDataPoints,
    ...hseEquipmentSiteAssetDataPoints,
    ...hseSiteAssetDataPoints,
    ...hseEquipmentAssetDataPoints,
    ...structureDataPoints
  };
  return typeOfDataFilterObjects;
};

const downloadDateFilter = (syncDateCustom, download) => {
  const currentDate = moment().format('YYYY-MM-DD');
  const syncDateCustomWithoutTimeZone = moment(syncDateCustom).format('YYYY-MM-DD');
  if (download?.selected === 'last' && !_.isEmpty(syncDateCustom)) return true;

  if (download?.selected === 'on') {
    const selectedDate = moment(download.value).format('YYYY-MM-DD');
    if (moment(syncDateCustom).isSame(moment(selectedDate))) return true;
  }

  if (download?.selected === 'range') {
    const selectedDateStart = moment(download.value[0]).format('YYYY-MM-DD');
    const selectedDateEnd = moment(download.value[1]).format('YYYY-MM-DD');
    if (
      moment(selectedDateStart).isSame(moment(selectedDateEnd)) &&
      moment(syncDateCustom).isSame(moment(selectedDateEnd))
    )
      return true;
    else if (moment(syncDateCustom).isBetween(selectedDateStart, selectedDateEnd)) return true;
  }

  if (download?.selected === 'past') {
    if (download.value?.includes('Day')) {
      const currentDateDecreaseByOneDay = moment().subtract('1', 'd').format('YYYY-MM-DD');
      if (moment(syncDateCustomWithoutTimeZone).isSame(moment(currentDateDecreaseByOneDay)))
        return true;
    }
    if (download.value?.includes('Week (7 days)')) {
      const currentDateDecreaseBySevenDay = moment().subtract('1', 'w').format('YYYY-MM-DD');
      if (
        moment(syncDateCustomWithoutTimeZone).isBetween(
          currentDateDecreaseBySevenDay,
          currentDate,
          undefined,
          '[)'
        )
      )
        return true;
    }

    if (download.value?.includes('Month (30 days)')) {
      const currentDateDecreaseBy30Day = moment().subtract('1', 'M').format('YYYY-MM-DD');
      if (
        moment(syncDateCustomWithoutTimeZone).isBetween(
          currentDateDecreaseBy30Day,
          currentDate,
          undefined,
          '[)'
        )
      )
        return true;
    }
    if (download.value?.includes('Quarter (90 days)')) {
      const currentDateDecreaseBy90Day = moment().subtract('90', 'd').format('YYYY-MM-DD');
      if (
        moment(syncDateCustomWithoutTimeZone).isBetween(
          currentDateDecreaseBy90Day,
          currentDate,
          undefined,
          '[)'
        )
      )
        return true;
    }
    if (download.value?.includes('Year (365 days)')) {
      const currentDateDecreaseBy365Day = moment().subtract('1', 'y').format('YYYY-MM-DD');
      if (
        moment(syncDateCustomWithoutTimeZone).isBetween(
          currentDateDecreaseBy365Day,
          currentDate,
          undefined,
          '[)'
        )
      )
        return true;
    }
    if (download.value?.includes('Unlimited')) {
      const currentDateDecreaseBy365Day = moment().subtract('100', 'y').format('YYYY-MM-DD');
      if (
        moment(syncDateCustomWithoutTimeZone).isBetween(
          currentDateDecreaseBy365Day,
          currentDate,
          undefined,
          '[)'
        )
      )
        return true;
    }
  } else {
    return false;
  }
};

export const getTasksLength = (runs, templates, templateData, tasks) => {
  if (runs?.length > 0 || templates?.length > 0) {
    let count = 0;
    for (const el of templateData) count += el.tasks.length;
    return count;
  }

  return tasks.length;
};

export const getCheckedLength = (runs, templates, templateData, tasks) => {
  if (runs?.length > 0 || templates?.length > 0) {
    let listOfSelectedTaskThatHaveUTSection = [];
    let count = 0;
    for (const el of templateData) {
      for (const task of el.tasks) {
        if (task.checked) count++;
        if (task?.checked && task?.hasUTData) {
          listOfSelectedTaskThatHaveUTSection.push({
            inspectableItemId: task?._id,
            equipmentId: task?.equipmentId
          });
        }
      }
    }
    return { checkedLength: count, listOfSelectedTaskThatHaveUTSection };
  }

  let selectedTaskLength = 0;
  let listOfSelectedTaskThatHaveUTSection = [];
  for (let task of tasks) {
    if (task?.checked) selectedTaskLength++;
    if (task?.checked && task?.hasUTData) {
      listOfSelectedTaskThatHaveUTSection.push({
        inspectableItemId: task?._id,
        equipmentId: task?.equipmentId
      });
    }
  }
  return { checkedLength: selectedTaskLength, listOfSelectedTaskThatHaveUTSection };
};
export const getQuickCheckedLength = ({ inspections, store }) => {
  const { inspection } = store;
  const { inspectionFormsUserCacheMap = {}, failureCriteria } = inspection;
  const failureCriteriaMap = failureCriteria?.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
  }, {});
  return inspections.reduce((acc, curr) => {
    if (inspectionFormsUserCacheMap[curr?.inspectionFormId]?.quickComplete && curr.checked) acc++;
    return acc;
  }, 0);
};

export const sortTasks = ({
  a,
  b,
  SelectedFilter,
  sitesMap,
  equipmentsMap,
  item,
  cacheEquipments = [],
  cacheSites = []
}) => {
  switch (Object.keys(SelectedFilter)[0]) {
    case 'RT ORDER':
    case 'RUN ORDER': {
      const rtNumberPrev =
        (a.rtNumber && a.rtNumber && a.rtNumber.split('-') && a.rtNumber.split('-')[1]) || null;
      const rtNumberNext =
        (b.rtNumber && b.rtNumber && b.rtNumber.split('-') && b.rtNumber.split('-')[1]) || null;
      return parseInt(rtNumberPrev) - parseInt(rtNumberNext);
    }
    case 'A-Z': {
      return a.title && b.title
        ? a.title?.localeCompare(b.title)
        : a.runName && b.runName
        ? a.runName?.localeCompare(b.runName)
        : -1;
    }
    case 'SCHEDULED': {
      if (a.startDate && b.startDate) return moment(a.startDate).diff(moment(b.startDate), 'days');
      else if (a.startDate) return -1;
      else if (b.startDate) return 1;
      else return moment(a.dueDate).diff(moment(b.dueDate), 'days');
    }
    case 'DUE': {
      return moment(a.dueDate).diff(moment(b.dueDate));
    }
    case 'NEWEST':
    case 'RECENT': {
      if (item === 'To do') {
        if (a?.createdDate && b?.createdDate)
          return moment(a?.createdDate).diff(moment(b?.createdDate), 'days');
        else if (a?.createdDate) return -1;
        else if (b?.createdDate) return 1;
        else return moment(a.updatedAt).diff(moment(b.updatedAt), 'days');
      } else if (item === 'In progress' || item === 'Pending sync') {
        if (a.updatedAt && b.updatedAt) return moment(b.updatedAt).diff(moment(a.updatedAt));
        else if (a.updatedAt) return 1;
        else if (b.updatedAt) return -1;
        else return moment(a.createdAt).diff(moment(b.createdAt));
      } else if (item === 'Synced') {
        // if (a.createdDate && b.createdDate)
        //   return moment(b.createdDate).diff(moment(a.createdDate));
        if (a.syncedDate && b.syncedDate) return moment(b.syncedDate).diff(moment(a.syncedDate));
        else if (a.syncedDate) return 1;
        else if (b.syncedDate) return -1;
        else return moment(a.dueDate).diff(moment(b.dueDate));
      } else {
        return 1;
      }
    }
    case 'DISTANCE': {
      const sitesAsset1 = [
        a.siteId,
        ...(a.sites ? a.sites.filter((site) => site !== a.siteId) : [])
      ].filter((site) => cacheSites[sitesMap[site]])[0];

      const equipmentsAsset1 = [
        a.equipmentId,
        ...(a?.equipments ? a.equipments.filter((equipment) => equipment !== a.equipmentId) : [])
      ].filter((equipment) => cacheEquipments[equipmentsMap[equipment]])[0];

      const equipment1 = cacheEquipments[equipmentsMap[equipmentsAsset1]] || {};
      const equipment1Site = equipment1.siteId || '';

      const sitesAsset2 = [
        b.siteId,
        ...(b.sites ? b.sites.filter((site) => site !== b.siteId) : [])
      ].filter((site) => cacheSites[sitesMap[site]])[0];

      const equipmentsAsset2 = [
        b.equipmentId,
        ...(b.equipments ? b.equipments.filter((equipment) => equipment !== b.equipmentId) : [])
      ].filter((equipment) => cacheEquipments[equipmentsMap[equipment]])[0];

      const equipment2 = cacheEquipments[equipmentsMap[equipmentsAsset2]] || {};
      const equipment2Site = equipment2.siteId || '';

      const distance1 =
        (cacheSites[sitesMap[sitesAsset1]] && cacheSites[sitesMap[sitesAsset1]]?.distance) ||
        (equipment1Site && cacheSites[sitesMap[equipment1Site]]?.distance) ||
        0;

      const distance2 =
        (cacheSites[sitesMap[sitesAsset2]] && cacheSites[sitesMap[sitesAsset2]]?.distance) ||
        (equipment2Site && cacheSites[sitesMap[equipment2Site]]?.distance) ||
        0;

      if (distance1 === null || distance1 === undefined || !distance1) return 1;
      if (distance2 === null || distance2 === undefined || !distance2) return -1;

      return distance1 - distance2;
    }
  }
};

export const getPendingTaskAndPhotosLength = ({
  pending,
  pendingInspections,
  pendingHse,
  pendingChecks,
  syncFailedAssets,
  pendingEquipment = []
}) => {
  let photos = 0,
    documents = 0,
    workOrder = 0,
    workRequest = 0,
    inspection = 0,
    hseEvents = 0,
    checks = 0,
    newEquipmentAssets = 0,
    editedEquipmentAssets = 0,
    photoIds = [],
    documentIds = [];

  pending?.map((task) => {
    const taskFormDataPhotosAndDocuments = getPhotosAndDocumentsDataFromSelectedInspection(
      task?.formData || {}
    );

    if (taskFormDataPhotosAndDocuments?.photos?.length) {
      photos += taskFormDataPhotosAndDocuments?.photos?.length;
      const photoId = taskFormDataPhotosAndDocuments?.photos?.map((x) => x?.id);
      photoIds.push(...photoId);
    }
    if (taskFormDataPhotosAndDocuments?.documents?.length) {
      documents += taskFormDataPhotosAndDocuments?.documents?.length;
      const documentId = taskFormDataPhotosAndDocuments?.documents?.map((x) => x?.id);
      documentIds.push(...documentId);
    }

    if (task?.photos?.length) {
      const photosDownload = task?.photos?.filter((x) => !_.isEmpty(x?.content)) || [];
      photos += photosDownload?.length || 0;
      const photoId = photosDownload?.map((x) => x?.id);
      photoIds.push(...photoId);
    }

    if (task?.documents?.length) {
      const documentsDownload = task?.documents?.filter((x) => !_.isEmpty(x?.content)) || [];
      documents += documentsDownload?.length || 0;
      const documentId = documentsDownload?.map((x) => x?.id);
      documentIds.push(...documentId);
    }

    if (!task?.newWorkRequest) ++workOrder;
    if (task?.newWorkRequest) ++workRequest;
    return task;
  });
  pendingInspections?.map((ins) => {
    const inspectionPhotosAndDocuments = getPhotosAndDocumentsDataFromSelectedInspection(
      ins?.formData || {}
    );

    if (ins?.type === 'Inspection') ++inspection;
    if (inspectionPhotosAndDocuments?.photos?.length) {
      const photoId = inspectionPhotosAndDocuments?.photos?.map((x) => x?.id);
      photoIds.push(...photoId);
      photos += inspectionPhotosAndDocuments?.photos?.length;
    }
    if (inspectionPhotosAndDocuments?.documents?.length) {
      const documentId = inspectionPhotosAndDocuments?.documents?.map((x) => x?.id);
      documentIds.push(...documentId);

      documents += inspectionPhotosAndDocuments?.documents?.length;
    }
    return ins;
  });
  pendingHse?.map((hseItems) => {
    const hsePhotosAndDocuments = getPhotosAndDocumentsDataFromSelectedInspection(
      hseItems?.formData || {}
    );

    if (hseItems?.type === 'HSE') ++hseEvents;
    if (hsePhotosAndDocuments?.photos?.length) {
      const photoId = hsePhotosAndDocuments?.photos?.map((x) => x?.id);
      photoIds.push(...photoId);
      photos += hsePhotosAndDocuments?.photos?.length;
    }
    if (hsePhotosAndDocuments?.documents?.length) {
      const documentId = hsePhotosAndDocuments?.documents?.map((x) => x?.id);
      documentIds.push(...documentId);
      documents += hsePhotosAndDocuments?.documents?.length;
    }
    return hseItems;
  });

  pendingChecks?.map((checkItems) => {
    const checkPhotosAndDocuments = getPhotosAndDocumentsDataFromSelectedInspection(
      checkItems?.formData || {}
    );

    if (checkItems?.type === 'Check') ++checks;
    if (checkPhotosAndDocuments?.photos?.length) {
      const photoId = checkPhotosAndDocuments?.photos?.map((x) => x?.id);
      photoIds.push(...photoId);
      photos += checkPhotosAndDocuments?.photos?.length;
    }
    if (checkPhotosAndDocuments?.documents?.length) {
      const documentId = checkPhotosAndDocuments?.documents?.map((x) => x?.id);
      documentIds.push(...documentId);
      documents += checkPhotosAndDocuments?.documents?.length;
    }
    return checkItems;
  });

  pendingEquipment?.map((equ) => {
    equ?.isNew ? ++newEquipmentAssets : ++editedEquipmentAssets;
    return equ;
  });
  return {
    documents,
    photos,
    workOrder,
    workRequest,
    inspection,
    checks,
    hseEvents,
    newEquipmentAssets,
    editedEquipmentAssets,
    inspectionPhotos: 0,
    equipmentRecords: 0,
    failedImageCount: syncFailedAssets?.photos?.length || 0,
    failedDocumentCount: syncFailedAssets?.documents?.length || 0,
    pendingSync:
      workOrder +
      workRequest +
      inspection +
      hseEvents +
      checks +
      newEquipmentAssets +
      editedEquipmentAssets,
    documentIds,
    photoIds
  };
};

const getPhotosAndDocumentsDataFromSelectedInspection = (obj) => {
  const photos = [],
    documents = [];
  let passFailTrue = 0,
    passFailFalse = 0,
    passFailNA = 0;

  const transformNestedObjects = (nestedObj) => {
    for (let key in nestedObj) {
      if (typeof nestedObj[key] === 'object' && nestedObj[key] !== null) {
        if ('photos' in nestedObj[key] && 'documents' in nestedObj[key]) {
          nestedObj[key].photos?.map((photo) => photos.push(photo));
          nestedObj[key].documents?.map((document) => documents.push(document));
        } else if ('photos' in nestedObj[key]) {
          if (nestedObj[key].photos && nestedObj[key]?.photos?.length) {
            nestedObj[key].photos?.map((photo) => photos.push(photo));
          }
        } else if ('documents' in nestedObj[key]) {
          if (nestedObj[key].documents && nestedObj[key].documents?.length) {
            nestedObj[key].documents?.map((document) => documents.push(document));
          }
        } else if ('answer' in nestedObj[key]) {
          if (nestedObj[key]?.answer === 'true') ++passFailTrue;
          if (nestedObj[key]?.answer === 'false') ++passFailFalse;
          if (nestedObj[key]?.answer === 'NA') ++passFailNA;
        }
      }
    }
  };
  // const transformWorkOrder = (a) => {
  //   for (let i = 0; i < a.length; i++) {
  //     let item = a[i];
  //     item?.photo?.map((photo) => photos.push(photo));
  //     item?.document?.map((document) => documents.push(document));
  //   }
  // };

  for (let key in obj) {
    // if (key === 'work order') {
    //   const a = obj[key];
    //   for (let key1 in a) {
    //     transformWorkOrder(a[key1]);
    //   }
    // } else
    if (!key.includes('ut information-')) transformNestedObjects(obj[key]);
  }

  return {
    photos,
    documents,
    passFailTrue,
    passFailNA,
    passFailFalse
  };
};
